import {Injectable, Injector} from "@angular/core";
import {PriceLevelScheduleData} from "./price-level-schedule.data";
import {PricingScheduleEntityModel} from "../pricing-schedule/pricing-schedule-entity.model";

@Injectable()
export class PriceLevelScheduleEntityModel extends PricingScheduleEntityModel<PriceLevelScheduleData> {
    constructor(injector: Injector) {
        super(injector, PriceLevelScheduleData);
    }

    protected override onBeforeSaveEntity(schedule: PriceLevelScheduleData): void {
        super.onBeforeSaveEntity(schedule);
        schedule.allTerminals = !schedule.terminals.length;
    }
}
